/** Renewal and ask-to-buy updates remain active after leaving the paywall. */
import { firstPurchaseConflict } from "@/lib/purchase_conflicts";
import { BillingRequestError } from "@/lib/billing";
import { claimPurchase } from "@/lib/billing";
import { refreshEntitlement } from "@/lib/entitlement";
import { bridge } from "@/native/impl";
import { PurchaseBatchError, PurchaseFlow } from "./purchases";
export const createPurchaseFlow = (): PurchaseFlow => new PurchaseFlow(bridge.purchases, claimPurchase, () => refreshEntitlement());
export function listenForPurchases(): () => void {
  const flow = createPurchaseFlow();
  return bridge.purchases.onUpdate((receipt) => {
    void flow.accept([receipt]).catch(async (cause: unknown) => {
      console.error("Purchase claim failed; transaction remains retryable:", cause);
      if (cause instanceof PurchaseBatchError) {
        let newFailure = false;
        for (const failure of cause.failures) {
          if (!(failure.cause instanceof BillingRequestError) || failure.cause.status !== 409 || await firstPurchaseConflict(failure.receipt)) newFailure = true;
        }
        if (!newFailure) return;
      }
      window.dispatchEvent(new CustomEvent("tally-purchase-error", { detail: cause instanceof Error ? cause.message : "Purchase could not be verified. Restore purchases to retry." }));
    }).catch((cause: unknown) => { console.error("Could not report purchase failure:", cause); });
  });
}
